import { useQuery } from '@tanstack/react-query';
import { QueryConfig, ExtractFnReturnType } from '../../../../lib/react-query';
import i18n from '../../../../i18n';
import { getCampaignClosedReasonSelect } from '../api/campaignClosedReason';

type QueryFnType = typeof getCampaignClosedReasonSelect;

type UseCampaignClosedReasonSelectOptions = {
    config?: QueryConfig<QueryFnType>;
};

export const useCampaignClosedReasonSelect = ({
    config = {}
}: UseCampaignClosedReasonSelectOptions = {}) => {

    const query = useQuery<ExtractFnReturnType<QueryFnType>>({
        ...config,
        queryKey: ['useCampaignClosedReasonSelect', i18n.language],
        queryFn: getCampaignClosedReasonSelect,
        refetchOnMount: false,
        refetchOnWindowFocus: false,
    });

    return {
        ...query,
        campaignClosedReasonData: query.data,
        fetchCampaignClosedReasonData: query.refetch,
    };
};